import { useEffect, useState, useRef, useMemo } from "react";

import "./styles.scss";

import { useParams } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";


import Screen from "@components/Screen";

import { CircularProgress } from "@mui/material";
import { EditRounded, DownloadRounded, ArrowBackIos, ArrowBackIosRounded } from "@mui/icons-material";

import { Button, Text } from '@fragments'

import ManageMaterialModal from "@modals/Material/ManageMaterial";

import { FullscreenRounded } from "@material-ui/icons";


import { useNavigate } from "react-router-dom";

export default function Content() {
    let { slug, materialId } = useParams();
    const { community, loading: communityLoading } = useCommunity()

    const navigate = useNavigate()

    const [material, setMaterial] = useState({});

    const [loading, setLoading] = useState(true);

    const [zoom, setZoom] = useState(1);

    const REF_materialModal = useRef()

    const [currentCommunity, setCurrentCommunity] = useState()


    useEffect(() => {
        if (loading) {
            handleLoadContent();
        }
    }, [loading]);

    useEffect(() => {
        if (!loading) setLoading(true);
    }, [materialId]);

    useEffect(() => {
        const comm = community.getBySlug(slug)
        if (comm) setCurrentCommunity({ ...comm })
    }, [slug, communityLoading])

    async function handleLoadContent() {
        try {
            const { data } = await api.get("material?id=" + materialId);
            setMaterial({ ...data });
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    }

    function PDFRender({ materialId, zoom }) {
        const containerRef = useRef(null);
        const [isRendering, setIsRendering] = useState(false);

        useEffect(() => {
            let cancelled = false;

            async function ensurePdfJs() {
                if (window.pdfjsLib) return window.pdfjsLib;
                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.min.js';
                    script.async = true;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
                window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
                return window.pdfjsLib;
            }

            async function render() {
                if (!materialId) return;
                setIsRendering(true);
                try {
                    const pdfjsLib = await ensurePdfJs();
                    const { data } = await api.get(`material/download?id=${materialId}`, { responseType: 'arraybuffer' });
                    if (cancelled) return;

                    const loadingTask = pdfjsLib.getDocument({ data });
                    const pdf = await loadingTask.promise;
                    if (cancelled) return;

                    const container = containerRef.current;
                    if (!container) return;
                    container.innerHTML = '';

                    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                        const page = await pdf.getPage(pageNum);
                        if (cancelled) return;

                        const baseViewport = page.getViewport({ scale: 1 });
                        const containerWidth = container.clientWidth || baseViewport.width;
                        const finalScale = (containerWidth / baseViewport.width) * zoom;
                        const viewport = page.getViewport({ scale: finalScale });

                        const canvas = document.createElement('canvas');
                        const context = canvas.getContext('2d');
                        const dpr = window.devicePixelRatio || 1;
                        canvas.width = Math.floor(viewport.width * dpr);
                        canvas.height = Math.floor(viewport.height * dpr);
                        canvas.style.width = `${viewport.width}px`;
                        canvas.style.height = `${viewport.height}px`;
                        context.setTransform(dpr, 0, 0, dpr, 0, 0);

                        const pageHost = document.createElement('div');
                        pageHost.style.position = 'relative';
                        pageHost.style.width = `${viewport.width}px`;
                        pageHost.style.height = `${viewport.height}px`;
                        pageHost.appendChild(canvas);
                        container.appendChild(pageHost);

                        await page.render({ canvasContext: context, viewport, intent: 'display' }).promise;

                        // Clickable links overlay
                        const annotations = await page.getAnnotations();
                        const overlay = document.createElement('div');
                        overlay.style.position = 'absolute';
                        overlay.style.left = '0';
                        overlay.style.top = '0';
                        overlay.style.width = `${viewport.width}px`;
                        overlay.style.height = `${viewport.height}px`;
                        overlay.style.pointerEvents = 'none';

                        for (const ann of annotations) {
                            if (ann.subtype === 'Link' && ann.url) {
                                const rect = pdfjsLib.Util.normalizeRect(viewport.convertToViewportRectangle(ann.rect));
                                const [x1, y1, x2, y2] = rect;
                                const link = document.createElement('a');
                                link.href = ann.url;
                                link.target = '_blank';
                                link.rel = 'noopener noreferrer';
                                link.style.position = 'absolute';
                                link.style.left = `${x1}px`;
                                link.style.top = `${y2}px`;
                                link.style.width = `${x2 - x1}px`;
                                link.style.height = `${y1 - y2}px`;
                                link.style.pointerEvents = 'auto';
                                link.style.background = 'rgba(0,0,0,0)';
                                overlay.appendChild(link);
                            }
                        }
                        pageHost.appendChild(overlay);
                    }
                } catch (e) {
                    console.log(e);
                }
                setIsRendering(false);
            }

            render();
            return () => {
                cancelled = true;
            };
        }, [materialId, zoom]);

        return (
            <div className="pdf-wrapper">
                <div className="pdf-viewport" ref={containerRef} />
            </div>
        );
    }

    async function handleDownload() {
        try {
            const response = await fetch(material?.path, { credentials: 'omit' });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${material?.name || 'material'}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.log(e);
        }
    }

    function handleOpenEditMaterial() {
        REF_materialModal.current.open(material, function (result) {
            if (result?.id) {
                setLoading(true)
            }
        })
    }

    function handleGoBack() {
        navigate(-1)
    }


    return (
        <Screen
            fullWidth={true}
            disablePaddingBottom
            className="material-view-page">
            <div className="material-container pb-6">
                {!loading && material?.path && material?.can_access ? (
                    <PDFRender materialId={materialId} zoom={zoom} />
                ) : (
                    null
                )}
            </div>

            {
                !loading && !material?.can_access && <h4 className="mt-8">Você não tem acesso a este material</h4>
            }

            {
                material?.can_access && (
                    <div className="material-footer">
                        <div className="material-footer__content">
                            <Text.h4 className="material-footer__title" title={material?.name || ''}>
                                {material?.name || ''}
                            </Text.h4>

                            <div className="material-actions">
                                <Button
                                    className="download-file-btn"
                                    variant="contained"
                                    size="medium"
                                    color="overlay"
                                    startIcon={<ArrowBackIosRounded />}
                                    onClick={handleGoBack}
                                >
                                    Voltar
                                </Button>
                                {currentCommunity?.isAdmin() && (
                                    <Button
                                        className="download-file-btn"
                                        variant="contained"
                                        size="medium"
                                        color="overlay"
                                        startIcon={<EditRounded />}
                                        onClick={handleOpenEditMaterial}
                                    >
                                        Editar
                                    </Button>
                                )}
                                <Button
                                    className="download-file-btn"
                                    variant="contained"
                                    size="medium"
                                    startIcon={<DownloadRounded />}
                                    onClick={handleDownload}
                                >
                                    Download
                                </Button>
                            </div>

                        </div>
                    </div>
                )
            }

            {
                loading && <div style={{
                    height: '100%',
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}><CircularProgress color="white" /></div>
            }

            <ManageMaterialModal modalRef={REF_materialModal} />
        </Screen>
    );
}
